import { CrmTenants } from '../../../../../store/api/crmTenants/types';
import { TenantRow } from '../types';
import { createRowFromTenant } from './createRow';

export const tenantsToRows = (tenants: CrmTenants = {}): TenantRow[] =>
  Object.entries(tenants).map(([key, value]) => createRowFromTenant(key, value));

export const rowsToTenants = (rows: TenantRow[]): CrmTenants =>
  rows.reduce<CrmTenants>((acc, { key, value }) => {
    const trimmedKey = key.trim();
    const trimmedValue = value.trim();

    if (trimmedKey && trimmedValue) {
      acc[trimmedKey] = trimmedValue;
    }

    return acc;
  }, {});

const snapshotRows = (rows: TenantRow[]) =>
  rows
    .map(({ key, value }) => ({ key: key.trim(), value: value.trim() }))
    .filter(({ key, value }) => key || value);

export const areRowsEqualToTenants = (rows: TenantRow[], tenants: CrmTenants): boolean =>
  JSON.stringify(snapshotRows(rows)) === JSON.stringify(snapshotRows(tenantsToRows(tenants)));
